import React from "react";
import { Field } from "./editorShared";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Textarea } from "../ui/textarea";

export default function MetadataSection({ q, set }) {
  return (
    <section className="bg-card border border-slate-200/80 rounded-xl p-6 shadow-sm">
      <h2 className="text-base font-semibold text-slate-900 mb-5">Dati Progetto</h2>
      <div className="space-y-5">
        <Field label="Titolo Progetto">
          <Input data-testid="quote-editor-title-input" value={q.title} onChange={(e) => set("title", e.target.value)} placeholder="Es. Sviluppo sito e-commerce" />
        </Field>
        <Field label="Data di Scadenza">
          <Input data-testid="quote-editor-due-date" type="date" value={q.due_date || ""} onChange={(e) => set("due_date", e.target.value)} className="w-full sm:w-56" />
        </Field>
        <Field label="Valuta">
          <Select value={q.currency || "EUR"} onValueChange={(v) => set("currency", v)}>
            <SelectTrigger data-testid="quote-editor-currency" className="w-full sm:w-56"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="EUR">EUR — Euro (€)</SelectItem>
              <SelectItem value="USD">USD — Dollaro USA ($)</SelectItem>
              <SelectItem value="GBP">GBP — Sterlina (£)</SelectItem>
              <SelectItem value="CHF">CHF — Franco svizzero</SelectItem>
              <SelectItem value="CAD">CAD — Dollaro canadese</SelectItem>
              <SelectItem value="AUD">AUD — Dollaro australiano</SelectItem>
            </SelectContent>
          </Select>
        </Field>
        <Field label="Descrizione Introduttiva">
          <Textarea value={q.description} onChange={(e) => set("description", e.target.value)} rows={3} placeholder="Breve introduzione al progetto…" />
        </Field>
      </div>
    </section>
  );
}
